/* eslint-disable @next/next/no-img-element */
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { getImage } from '@utils/imageHelper';
import { K12_LANDING_PAGE_DOWNLOAD_APP_CLICKED } from '@constants/segment';
import { segment } from '@actions/analytics';
import Confetti from '../Confetti';
import {
  SuccessMessageTitle,
  SuccessMessageSubTitle,
  SuccessFulCover,
  SuccessFulContent,
  Download,
  DownloadCover,
  DownloadHeader,
  DownloadTitle,
  DownloadSubTitle,
  DownloadContent,
  PlayStoreIcon,
  AppImageWrapper,
  AppImage,
  Divider,
  PlayStoreButton
} from './styles';

const Flex = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
`;
const AppImageSrc = 'leadGen/appNew.png';
const SuccessFul = ({ success, type, activityType, state, getGoalName }) => {
  const { goal_uid } = state;
  const goalName = getGoalName(goal_uid);
  const { header, footer } = success;
  const isLeadGenForm = type === 'leadGen';
  const link =
    'https://play.google.com/store/apps/details?id=com.unacademyapp&referrer=utm_source%3DLeadGen%26utm_medium%3DWebApp%26utm_campaign%3DLeadGen%26';
  const handleClick = () => {
    const data = {
      activity_type: activityType,
      goal_uid,
      goal_name: goalName
    };
    segment.track(K12_LANDING_PAGE_DOWNLOAD_APP_CLICKED, data);
    window.open(link, '_blank', 'noopener');
  };
  return (
    <>
      <SuccessFulCover $isLeadGenForm={isLeadGenForm}>
        <SuccessFulContent $isLeadGenForm={isLeadGenForm}>
          <Confetti />
          <SuccessMessageTitle>{header.title}</SuccessMessageTitle>
          <SuccessMessageSubTitle>{header.description}</SuccessMessageSubTitle>
        </SuccessFulContent>
      </SuccessFulCover>
      <Download $isLeadGenForm={isLeadGenForm}>
        <Divider $isLeadGenForm={isLeadGenForm} />
        <DownloadCover $isLeadGenForm={isLeadGenForm}>
          <DownloadHeader>{footer.title}</DownloadHeader>
          <DownloadTitle>{footer.subtitle}</DownloadTitle>
          <DownloadSubTitle $isLeadGenForm={isLeadGenForm}>
            {footer.description}
          </DownloadSubTitle>
        </DownloadCover>
        <DownloadContent $isLeadGenForm={isLeadGenForm}>
          <AppImageWrapper>
            <AppImage src={AppImageSrc} alt="app" width={200} height={200} />
          </AppImageWrapper>
          <Flex>
            <PlayStoreButton onClick={handleClick} type="button">
              <img
                src={getImage('playStore_resized.svg')}
                alt="download"
                height="42"
                width="128"
              />
            </PlayStoreButton>
            <PlayStoreIcon
              type="appleStore"
              $isLeadGenForm={isLeadGenForm}
              href="https://play.google.com/store/apps/details?id=com.unacademyapp&referrer=utm_source%3DLeadGen%26utm_medium%3DWebApp%26utm_campaign%3DLeadGen%26"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={getImage('appStore_resized.svg')}
                alt="download"
                height="42"
                width="128"
              />
            </PlayStoreIcon>
          </Flex>
        </DownloadContent>
      </Download>
    </>
  );
};

SuccessFul.propTypes = {
  success: PropTypes.objectOf(PropTypes.any).isRequired,
  type: PropTypes.string.isRequired,
  activityType: PropTypes.string.isRequired,
  state: PropTypes.objectOf(PropTypes.any).isRequired
};

export default SuccessFul;
